import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Router } from '@angular/router'

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  constructor(
    private http: HttpClient,
    private router: Router
  ) {}

  login(email: any, password: any) {
    return this.http.post('user/login', {
      email: email,
      password: password
    })
  }

  logout() {
    // Clear the server-side HttpOnly auth cookie, then drop local UI state and redirect.
    this.http.post('User/Logout', {}).subscribe({
      next: () => this.clearLocalSession(),
      error: () => this.clearLocalSession()
    })
  }

  private clearLocalSession() {
    // localStorage.clear();
    localStorage.removeItem('userMail')
    localStorage.removeItem('authToken')
    localStorage.removeItem('user')
    localStorage.removeItem('pusherTransportTLS')
    this.router.navigate(['/login'])
  }

  confirmEmail(params: any) {
    return this.http.get(
      `user/confirmemail?token=${params.token}&email=${params.email}`
    )
  }

  confirmOtpAndLogin(otp: any, email: any) {
    return this.http.post('user/confirmotp', {
      otp: otp,
      email: email
    })
  }

  forgetPassword(email: any) {
    return this.http.post('User/ForgetPassword', {
      email: email
    })
  }

  resetPassword(body: any) {
    return this.http.post('User/ResetPassword', body)
  }

  isAdmin() {
    const role = JSON.parse(localStorage.getItem('user') as string)?.role
    return role === 'Admin' ? true : false
  }
  isSuperAdmin() {
    const role = JSON.parse(localStorage.getItem('user') as string)?.role
    return role === 'SuperAdmin' ? true : false
  }
  isEmployee() {
    const role = JSON.parse(localStorage.getItem('user') as string)?.role
    if (role !== 'SuperAdmin') {
      return true
    } else {
      return false
    }
  }

  getDepartmentId() {
    const riskOwnerId = JSON.parse(
      localStorage.getItem('user') as any
    )?.departmentId
    return riskOwnerId ? riskOwnerId : null
  }
}
